import { apolloClient } from '../../../plugins/apollo-client';
import { GET_COMPANY, GET_SELL_CHANNELS } from '../queries/companies/companies.queries';

export const getCompany = async ({ code }) => apolloClient.query({ query: GET_COMPANY, variables: { code }});
export const getSellChannels = () => apolloClient.query({ query: GET_SELL_CHANNELS });

export const companiesService = {
  getCompany,
  getSellChannels,
};